import { useState } from 'react';

const STORAGE_KEY = 'gedready-onboarded';

export default function Onboarding({ onDone, t }) {
  const [slide, setSlide] = useState(0);
  const slides = t('onboarding');
  const isLast = slide === slides.length - 1;

  function handleNext() {
    if (isLast) { localStorage.setItem(STORAGE_KEY, '1'); onDone(); }
    else setSlide(s => s + 1);
  }

  function handleSkip() { localStorage.setItem(STORAGE_KEY, '1'); onDone(); }

  const { icon, title, body } = slides[slide];

  return (
    <div className="onboarding-backdrop">
      <div className="onboarding-modal">
        <div className="onboarding-icon">{icon}</div>
        <h2 className="onboarding-title">{title}</h2>
        <p className="onboarding-body">{body}</p>

        <div className="onboarding-dots">
          {slides.map((_, i) => (
            <div key={i} className={`onboarding-dot ${i === slide ? 'onboarding-dot--active' : ''}`} />
          ))}
        </div>

        <button className="primary-btn onboarding-next"
          style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}
          onClick={handleNext}>
          {isLast ? t('letsStart') : t('next')}
        </button>

        {!isLast && <button className="back-link" onClick={handleSkip}>{t('skip')}</button>}
      </div>
    </div>
  );
}
